import { widgetAssetUrl } from '../../../utils/widgetAssetUrl';

/**
 * Hero photo and video of the Andys landing (#1108, load time — #1469).
 *
 * The landing is Andys' mobile homepage, so whatever the hero costs, every
 * first visit pays it before the page is usable.
 */

// Andys storefront photo (from andys-motors.com), 1080 px WebP, ≈94 KB. Loaded
// from the widget host, not imported: the library build inlined the 1.7 MB JPEG
// as base64, half of the whole bundle.
export const ANDYS_HERO_IMAGE = widgetAssetUrl('assets/landing/andys-hero.webp');

// Andys showroom loop: a cut of their homepage video
// (andys-motors.com/assets/images/videos/andys-motors-compressed.mp4) with the
// title cards and captions taken out — source 7.2–11.3 s + 12.2–24.3 s, so no
// text in the video competes with the landing headline. 960×540 H.264 at
// 1 Mbps, no audio, 16 s, ≈2.1 MB; the original is 4K, 30 s and 102 MB.
// Config/mount-overridable via the heroVideoUrl prop.
export const ANDYS_HERO_VIDEO = widgetAssetUrl('assets/landing/andys-hero.mp4');

// The video starts this long after the landing appears, so it doesn't compete
// with the bundle, the inventory and the photo for a phone's bandwidth.
export const HERO_VIDEO_DELAY_MS = 1500;

const SLOW_CONNECTIONS = new Set(['slow-2g', '2g', '3g']);

/**
 * Whether to play the hero video at all. Visitors who asked to save data, are
 * on a slow connection or prefer reduced motion keep the photo, which is also
 * the video's poster. Safari has no `navigator.connection`; there the video
 * plays unless reduced motion is on.
 *
 * @param {Window} [win]
 */
export function shouldPlayHeroVideo(win = typeof window !== 'undefined' ? window : undefined) {
  if (!win) return false;
  const connection = win.navigator?.connection;
  if (connection?.saveData) return false;
  if (connection && SLOW_CONNECTIONS.has(connection.effectiveType)) return false;
  if (win.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return false;
  return true;
}
